import React from "react";
import FundingStory from "./FundingStory";
import ArticleTeaser from "./ArticleTeaser";

import { ApiResult } from "../../../lib/CmsApi";
import HeaderWithIntro from "../../common/HeaderWithIntro";
import Button from "../../common/Button";
import { AlignRightOnTablet } from "../../common/AlignRight";
import CheckerboardComponent from "../../common/CheckerboardComponent";
import Slider from "../../Slider";
import styled from "styled-components";
import { spacing } from "../../theme";

const SliderWrap = styled.div`
  ${spacing("margin-bottom", 80)}
`;

export interface MagazineTeaserProps {
  portraits?: ApiResult<"listMagazinPortraits">;
  news?: ApiResult<"listMagazinNews">;
  overline: string;
  className?: string;
}
const MagazineTeaserComponent = (p: MagazineTeaserProps) => {
  if (
    (!p.portraits && !p.news) ||
    (p.portraits.total === 0 && p.news.total === 0)
  ) {
    return null;
  }
  return (
    <div className={p.className}>
      <HeaderWithIntro
        headline="Aktuelles &amp; Wissenswertes"
        size={1}
        level={2}
        overline={p.overline}
      >
        <AlignRightOnTablet>
          <Button route={"magazin"}>Zum Magazin</Button>
        </AlignRightOnTablet>
      </HeaderWithIntro>
      {p.portraits && p.portraits.total > 0 && (
        <SliderWrap>
          <Slider
            itemCountXLarge={1}
            itemCountLarge={1}
            itemCountMedium={1}
            itemCountSmall={1}
            ariaLabel="Ausgewählte Förderportraits"
          >
            {p.portraits.items.map(item => (
              <FundingStory
                key={item.slug}
                {...(item as any)}
                noBottomMargin
                small
              />
            ))}
          </Slider>
        </SliderWrap>
      )}
      <CheckerboardComponent>
        {p.news &&
          p.news.total > 0 &&
          p.news.items.map((item, idx) => (
            <ArticleTeaser
              key={item.slug}
              swap={idx % 2 !== 0}
              {...item}
              deeperHeading
            />
          ))}
      </CheckerboardComponent>
    </div>
  ); //TODO: Fix any
};

MagazineTeaserComponent.getImages = (props: MagazineTeaserProps) => {
  let images = [];

  props.portraits.items.forEach(el => {
    images = images.concat(FundingStory.getImages(el));
  });

  props.news.items.forEach(el => {
    images = images.concat(ArticleTeaser.getImages(el));
  });

  return images;
};
export default MagazineTeaserComponent;
